import { isMobileDevice } from '#pplx/frontend/user-agent-parser/device.js';
function isServiceWorkerSupported() {
    return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}
export function isBrowserPushSupported() {
    return (isServiceWorkerSupported() && 'PushManager' in window && !isMobileDevice(navigator.userAgent));
}
export async function getActiveRegistration() {
    if (!isServiceWorkerSupported())
        return null;
    return (await navigator.serviceWorker.getRegistration('/')) ?? null;
}
export async function getActivePushSubscription() {
    if (!isBrowserPushSupported())
        return null;
    const registration = await getActiveRegistration();
    if (!registration?.pushManager)
        return null;
    return registration.pushManager.getSubscription();
}
//# sourceMappingURL=capability.js.map